<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            Inventario Detallado
            <router-link
              :to="{ name: 'InventarioActual', params: { almacen: almacen } }"
            >
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody>
            <div class="d-flex align-items-center flex-wrap flex-sm-nowrap">
              <label style="width:76px;">Almacén: </label>
              <CCol md="6" lg="6">
                <template>
                  <CInput lg="6" :disabled="true" v-model="almacenNombre" />
                </template>
              </CCol>
            </div>
            <div class="d-flex align-items-center flex-wrap flex-sm-nowrap">
              <label style="width:76px;">Categoría: </label>
              <CCol md="6" lg="6">
                <template>
                  <CInput lg="6" :disabled="true" v-model="categoria" />
                </template>
              </CCol>
            </div>
            <div class="d-flex align-items-center flex-wrap flex-sm-nowrap">
              <label style="width:76px;">Producto: </label>
              <CCol md="6" lg="6">
                <template>
                  <CInput lg="6" :disabled="true" v-model="producto" />
                </template>
              </CCol>
            </div>
            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="items"
              :fields="fields"
              :noItemsView="noItems"
            >
              <!-- <template #ALMACEN_NOMBRE="{ item }">
                <td class="py-2">{{ item.almacen }}</td>
              </template>
              <template #CATEGORIA="{ item }">
                <td class="py-2">{{ item.categoria }}</td>
              </template>
              <template #PRODUCTO_NOMBRE="{ item }">
                <td class="py-2">{{ item.producto }}</td>
              </template> -->
              <template #FECHA="{ item }">
                <td class="py-2">{{ item.fecha }}</td>
              </template>
              <template #CANTIDAD="{ item }">
                <td class="py-2 text-right">{{ $formatter(item.cantidad) }}</td>
              </template>
              <template #COSTO_UNITARIO="{ item }">
                <td class="py-2 text-right">
                  {{ $formatter(item.costo_unitario, true) }}
                </td>
              </template>
              <template #COSTO="{ item }">
                <td class="py-2 text-right">
                  {{ $formatter(item.cantidad * item.costo_unitario, true) }}
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

const fields = [
  // { key: "ALMACEN_NOMBRE", label: "Almacén", _style: "width:10%" },
  // { key: "CATEGORIA", label: "Categoría", _style: "width:10%" },
  // { key: "PRODUCTO_NOMBRE", label: "Producto Nombre", _style: "width:10%" },
  { key: "FECHA", label: "Fecha", _style: "width:10%" },
  {
    key: "CANTIDAD",
    label: "Existencia Actual",
    _style: "width:10%; text-align: center"
  },
  {
    key: "COSTO_UNITARIO",
    label: "Costo Unitario",
    _style: "width:10%; text-align: center"
  },
  {
    key: "COSTO",
    label: "Costo Total",
    _style: "width:10%; text-align: center"
  }
];

export default {
  name: "InvetarioDetallado",

  components: {
    Multiselect
  },

  data() {
    return {
      producto: this.$route.params.producto,
      almacen: this.$route.params.almacen,
      almacenNombre: "",
      categoria: "",
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      items: [],
      fields,
      filter: "",
      isLoading: false
    };
  },

  created() {
    let productos = {
      schema: "productos",
      filter: {
        where: [
          {
            field: "payload->nombre",
            operator: "=",
            value: this.producto
          }
        ]
      }
    };
    Promise.all([this.$store.dispatch("customHTTP", productos)])
      .then(([productos]) => {
        this.actualizarInfo(productos.data[0].id);
      })
      .catch(rej => console.log(rej.message))
      .finally(() => (this.isLoading = true));
  },

  computed: {
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    getCostoTotal() {}
  },

  methods: {
    actualizarInfo(productoId) {
      this.isLoading = true;

      let template = {
        body: {
          reporte: "saldos_detallado",
          params: {
            almacen_id: this.almacen.value,
            producto_id: productoId,
            ubicaciones: [this.ubicacionRaiz]
          }
        }
      };

      Promise.all([this.$store.dispatch("customIndicadoresHTTP", template)])
        .then(([saldos]) => {
          this.items = saldos.data;
          this.almacenNombre = saldos.data[0].almacen;
          this.categoria = saldos.data[0].categoria;
          this.producto = saldos.data[0].producto;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
